import r from "./extends.mjs";
import "react";
import o from "./index180.mjs";
import { GlobalStyles as t } from "@mui/system";
import m from "./defaultTheme.mjs";
import p from "./identifier.mjs";
import { jsx as l } from "react/jsx-runtime";
function s(e) {
  return /* @__PURE__ */ l(t, r({}, e, {
    defaultTheme: m,
    themeId: p
  }));
}
process.env.NODE_ENV !== "production" && (s.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The styles you want to apply globally.
   */
  styles: o.oneOfType([o.array, o.func, o.number, o.object, o.string, o.bool])
});
export {
  s as default
};
//# sourceMappingURL=GlobalStyles.mjs.map
